webpackJsonp([96961042003272],{

/***/ 4022:
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(421);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(62);
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	
	
	var adjust = /*#__PURE__*/_curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});
	module.exports = adjust;

/***/ }),

/***/ 4023:
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var curryN = /*#__PURE__*/__webpack_require__(162);
	
	var max = /*#__PURE__*/__webpack_require__(424);
	
	var pluck = /*#__PURE__*/__webpack_require__(295);
	
	var reduce = /*#__PURE__*/__webpack_require__(193);
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	
	
	var allPass = /*#__PURE__*/_curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function () {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});
	module.exports = allPass;

/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _prop2 = __webpack_require__(38);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _map2 = __webpack_require__(32);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _pathOr2 = __webpack_require__(110);
	
	var _pathOr3 = _interopRequireDefault(_pathOr2);
	
	var _pipe2 = __webpack_require__(33);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _path2 = __webpack_require__(19);
	
	var _path3 = _interopRequireDefault(_path2);
	
	var _objectWithoutProperties2 = __webpack_require__(7);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _allPass2 = __webpack_require__(4023);
	
	var _allPass3 = _interopRequireDefault(_allPass2);
	
	var _filter2 = __webpack_require__(97);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _unless2 = __webpack_require__(297);
	
	var _unless3 = _interopRequireDefault(_unless2);
	
	var _assoc2 = __webpack_require__(188);
	
	var _assoc3 = _interopRequireDefault(_assoc2);
	
	var _propEq2 = __webpack_require__(64);
	
	var _propEq3 = _interopRequireDefault(_propEq2);
	
	var _when2 = __webpack_require__(298);
	
	var _when3 = _interopRequireDefault(_when2);
	
	var _adjust2 = __webpack_require__(4022);
	
	var _adjust3 = _interopRequireDefault(_adjust2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactI18next = __webpack_require__(11);
	
	var _recompose = __webpack_require__(26);
	
	var _camelCase = __webpack_require__(90);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _styles = __webpack_require__(21);
	
	var _utils = __webpack_require__(13);
	
	var _components = __webpack_require__(3);
	
	var _Layout = __webpack_require__(138);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Embed = __webpack_require__(137);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the padding from the first Body module if present
	var withoutTopBodyPadding = (0, _adjust3.default)((0, _when3.default)((0, _propEq3.default)("__typename", "ContentfulBody"), (0, _assoc3.default)("pt", 0)), 0);
	
	var getAlerts = (0, _unless3.default)(_isNil3.default, (0, _filter3.default)((0, _allPass3.default)([(0, _propEq3.default)("embedStyle", "Alert"), _Embed.isActiveArticle])));
	
	var TopPageMenu = function TopPageMenu(_ref) {
	  var page = _ref.page,
	      theme = _ref.theme;
	  return _react2.default.createElement(_components.PageMenu, {
	    page: page,
	    title: null,
	    theme: theme,
	    mb: 2,
	    px: 0,
	    borderBottom: true,
	    borderWidth: 1,
	    borderColor: "divider",
	    display: ["block", "block", "block", "none"],
	    listProps: {
	      flexDirection: "row",
	      style: {
	        overflowX: "auto"
	      },
	      mt: 0
	    },
	    itemProps: {
	      style: {
	        whiteSpace: "nowrap"
	      },
	      ml: 3,
	      mb: 2,
	      fontSize: 2
	    }
	  });
	};
	
	var Page = function Page(_ref2) {
	  var siteData = _ref2.siteData,
	      data = _ref2.data,
	      t = _ref2.t,
	      breadcrumb = _ref2.breadcrumb,
	      headerImages = _ref2.headerImages,
	      pathContext = _ref2.pathContext,
	      props = (0, _objectWithoutProperties3.default)(_ref2, ["siteData", "data", "t", "breadcrumb", "headerImages", "pathContext"]);
	
	  if (!data) {
	    return null;
	  }
	
	  var _data$contentfulPage = data.contentfulPage,
	      fullUrl = _data$contentfulPage.fullUrl,
	      pageTitle = _data$contentfulPage.title,
	      layoutName = _data$contentfulPage.layout,
	      metaDescription = _data$contentfulPage.metaDescription,
	      headerContent = _data$contentfulPage.headerContent,
	      content = _data$contentfulPage.content,
	      _data$contentfulPage$ = _data$contentfulPage.theme,
	      theme = _data$contentfulPage$ === undefined ? _styles.defaultTheme : _data$contentfulPage$,
	      bottomContent = _data$contentfulPage.bottomContent,
	      sidebarContent = _data$contentfulPage.sidebarContent,
	      relatedLinks = _data$contentfulPage.relatedLinks,
	      articles = _data$contentfulPage.articles,
	      _data$contentfulPage$2 = _data$contentfulPage.showSharingIcons,
	      showSharingIcons = _data$contentfulPage$2 === undefined ? false : _data$contentfulPage$2,
	      _data$contentfulPage$3 = _data$contentfulPage.suppressSidebar,
	      suppressSidebar = _data$contentfulPage$3 === undefined ? false : _data$contentfulPage$3,
	      _data$contentfulPage$4 = _data$contentfulPage.suppressBreadcrumb,
	      suppressBreadcrumb = _data$contentfulPage$4 === undefined ? false : _data$contentfulPage$4,
	      _data$contentfulPage$5 = _data$contentfulPage.suppressPageTitle,
	      suppressPageTitle = _data$contentfulPage$5 === undefined ? false : _data$contentfulPage$5,
	      _data$contentfulPage$6 = _data$contentfulPage.suppressNcuaLogo,
	      suppressNcuaLogo = _data$contentfulPage$6 === undefined ? false : _data$contentfulPage$6,
	      _data$contentfulPage$7 = _data$contentfulPage.suppressEhlLogo,
	      suppressEhlLogo = _data$contentfulPage$7 === undefined ? false : _data$contentfulPage$7;
	
	
	  var pageDescription = metaDescription && metaDescription.metaDescription;
	  var alerts = getAlerts(articles);
	
	  var layout = layoutName ? (0, _camelCase2.default)(layoutName) : undefined;
	
	  var tealiumTag = "\n  (function(a,b,c,d){\n    a=\"https://tags.tiqcdn.com/utag/adtaxi/fcfcu.com/prod/utag.js\";\n    b=document;c=\"script\";d=b.createElement(c);d.src=a;d.type=\"text/java\"+c;d.async=true;\n    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);\n    })();\n";
	
	  var universalPixel = "ttd_dom_ready( function() {\n                if (typeof TTDUniversalPixelApi === 'function') {\n                    var universalPixelApi = new TTDUniversalPixelApi();\n                    universalPixelApi.init(\"010w9rb\", [\"58uuxig\"], \"https://insight.adsrvr.org/track/up\");\n                }\n            });";
	
	  var secondaryPixel = "var $wc_load=function(a){return  JSON.parse(JSON.stringify(a))},$wc_leads=$wc_leads||{doc:{url:$wc_load(document.URL),ref:$wc_load(document.referrer),search:$wc_load(location.search),hash:$wc_load(location.hash)}};";
	
	  return _react2.default.createElement(
	    _Layout2.default,
	    {
	      data: data,
	      locale: (0, _utils.shortenLocaleName)(pathContext.locale),
	      alerts: alerts,
	      suppressEhlLogo: suppressEhlLogo,
	      suppressNcuaLogo: suppressNcuaLogo,
	      title: pageTitle,
	      layout: layout,
	      description: pageDescription,
	      headerImages: headerImages,
	      theme: theme,
	      breadcrumb: !suppressBreadcrumb && breadcrumb,
	      pageTitle: pageTitle,
	      renderAboveBreadcrumb: function renderAboveBreadcrumb() {
	        return _react2.default.createElement(
	          _react.Fragment,
	          null,
	          headerContent && _react2.default.createElement(_components.Content, {
	            content: headerContent,
	            theme: theme,
	            siteData: siteData
	          }),
	          !suppressSidebar && _react2.default.createElement(TopPageMenu, { page: data.contentfulPage, theme: theme })
	        );
	      },
	      renderSidebar: !suppressSidebar && function () {
	        return _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_components.PageMenu, {
	            page: data.contentfulPage,
	            title: t("layout.menuTitle"),
	            theme: theme,
	            mb: 4,
	            display: ["none", "none", "none", "block"]
	          }),
	          showSharingIcons && _react2.default.createElement(_components.Share, { url: fullUrl, mb: 4, description: pageDescription }),
	          relatedLinks && _react2.default.createElement(_components.RelatedLinks, { links: relatedLinks, theme: theme }),
	          sidebarContent && _react2.default.createElement(
	            _components.Box,
	            { mt: 3 },
	            _react2.default.createElement(_components.Content, {
	              content: sidebarContent,
	              theme: theme,
	              siteData: siteData,
	              condensed: true,
	              pageData: data
	            })
	          )
	        );
	      },
	      renderBottomContent: bottomContent && function () {
	        return _react2.default.createElement(_components.Content, {
	          content: bottomContent,
	          theme: theme,
	          siteData: siteData,
	          pageData: data
	        });
	      }
	    },
	    !suppressPageTitle && _react2.default.createElement(
	      _components.H1,
	      { color: (0, _styles.themeColor)(theme), px: [3, 3, 4], mt: 2 },
	      pageTitle
	    ),
	    content && _react2.default.createElement(_components.Content, {
	      content: suppressPageTitle ? content : withoutTopBodyPadding(content),
	      theme: theme,
	      siteData: siteData,
	      pageData: data
	    }),
	    _react2.default.createElement("script", {
	      type: "text/javascript",
	      dangerouslySetInnerHTML: { __html: tealiumTag }
	    }),
	    _react2.default.createElement("script", {
	      src: "//rum-static.pingdom.net/pa-66cf9b411ec1ac0012000084.js",
	      async: true
	    }),
	    _react2.default.createElement("script", {
	      src: "https://js.adsrvr.org/up_loader.1.1.0.js",
	      type: "text/javascript"
	    }),
	    _react2.default.createElement("script", {
	      type: "text/javascript",
	      dangerouslySetInnerHTML: { __html: universalPixel }
	    }),
	    _react2.default.createElement("script", {
	      type: "text/javascript",
	      dangerouslySetInnerHTML: { __html: secondaryPixel }
	    }),
	    _react2.default.createElement("script", { src: "//s.ksrndkehqnwntyxlhgto.com/140237.js" }),
	    _react2.default.createElement(
	      "script",
	      { id: "facebook-pixel-script" },
	      "!function(f,b,e,v,n,t,s)\n        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n        n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n        n.queue=[];t=b.createElement(e);t.async=!0;\n        t.src=v;s=b.getElementsByTagName(e)[0];\n        s.parentNode.insertBefore(t,s)}(window, document,'script',\n        'https://connect.facebook.net/en_US/fbevents.js');\n        fbq('init', '427292227998029');\n        fbq('track', 'PageView');"
	    ),
	    _react2.default.createElement(
	      "noscript",
	      { key: "image", id: "facebook-pixel-image" },
	      "<img\n          height=\"1\"\n          width=\"1\"\n          style=\"display:none\"\n          src=\"https://www.facebook.com/tr?id=427292227998029&ev=PageView&noscript=1\"\n        />"
	    ),
	    _react2.default.createElement("noscript", null),
	    _react2.default.createElement("img", {
	      height: "1",
	      width: "1",
	      style: { borderStyle: "none" },
	      alt: "",
	      src: "https://insight.adsrvr.org/track/pxl/?adv=010w9rb&ct=0:k5e2qdg&fmt=3"
	    }),
	    _react2.default.createElement("img", {
	      height: "1",
	      width: "1",
	      style: { borderStyle: "none" },
	      alt: "",
	      src: "https://insight.adsrvr.org/track/pxl/?adv=010w9rb&ct=0:rsf10td&fmt=3"
	    })
	  );
	};
	
	Page.propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var getHeaderImages = function getHeaderImages(props) {
	  var headerImages = (0, _path3.default)(["data", "contentfulPage", "headerImages"], props);
	
	  if (headerImages && headerImages.length) {
	    return headerImages;
	  }
	};
	
	exports.default = (0, _recompose.compose)((0, _reactI18next.translate)("translations"), (0, _recompose.withProps)(function (props) {
	  return {
	    siteData: {
	      events: (0, _pipe3.default)((0, _pathOr3.default)([], ["data", "allContentfulEvent", "edges"]), (0, _map3.default)((0, _prop3.default)("node")))(props)
	    },
	    breadcrumb: (0, _pathOr3.default)([], ["pathContext", "breadcrumb"], props),
	    headerImages: getHeaderImages(props)
	  };
	}))(Page);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-b19a6243056546e63ad8.js